export const lockScroll = {
  mounted() {
    if (this.withLock) document.getElementsByTagName('body')[0].classList.add('lock-scroll');
  },
  destroyed() {
    if (this.withLock) document.getElementsByTagName('body')[0].classList.remove('lock-scroll');
  },
};